import { render } from "./BaseSelectBox.vue?vue&type=template&id=4a93c60b"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__